import React from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import THEME from '../../../theme.js';
import Badge from '../../Badge.js';
import { Edit, XCircle } from '../../Icons/index.js';
const SecondaryEntity = (props) => {
    const { id, toggleEditModal, render, note, deleteEventType, enabled } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(Edit, { style: {
                cursor: 'pointer',
                float: 'right',
                marginLeft: '5px',
            }, onClick: () => toggleEditModal() }),
        React.createElement(XCircle, { style: {
                cursor: 'pointer',
                float: 'right',
            }, onClick: async () => {
                await customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
                    type: deleteEventType,
                    details: {
                        id,
                    },
                });
                await c.customers.getById(props.user.customerId);
            } }),
        render,
        note ? React.createElement("small", null,
            " - ",
            note) : '',
        ' ',
        !enabled && (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.customers.secondaryEntityDisabled))));
};
export default SecondaryEntity;
//# sourceMappingURL=SecondaryEntity.js.map